// Self-hosted consent management — replaces Cookiebot
// Reads/writes a simple cookie to track user's consent choice.
// Geo-aware: only EU/EEA/UK/CH/BR visitors see the banner.

import { API_BASE_URL } from '../config/runtime';

const COOKIE_NAME = 'magi_consent';
const COOKIE_DAYS = 365;

// Consent values stored in cookie:
//   'all'       — accepted all cookies
//   'necessary' — rejected non-essential
const _listeners = new Set();

const _readCookie = () => {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
};

const _writeCookie = (value) => {
    const expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(value)};expires=${expires};path=/;SameSite=Lax;Secure`;
    _listeners.forEach(fn => fn(value));
};

/** Returns true if user has consented to statistics/analytics tracking */
export const hasAnalyticsConsent = () => {
    if (typeof window === 'undefined') return false;
    const consent = _readCookie();
    if (consent === null) return false;
    return consent === 'all';
};

/** Returns true if user has already responded to the consent banner */
export const hasResponded = () => _readCookie() !== null;

/** Accept all cookies */
export const acceptAll = () => _writeCookie('all');

/** Reject non-essential cookies */
export const rejectNonEssential = () => _writeCookie('necessary');

/** Check if visitor is in a region that requires a consent banner.
 *  Returns true if banner should be shown.
 *  Auto-accepts for non-EU visitors (no banner needed). */
export const checkRequiresConsentBanner = async () => {
    if (hasResponded()) return false;

    const cached = sessionStorage.getItem('_geo');
    if (cached !== null) {
        if (cached === '0') { acceptAll(); return false; }
        return true;
    }

    try {
        const res = await fetch(`${API_BASE_URL}/api/geo`);
        const data = await res.json();
        sessionStorage.setItem('_geo', data.eu ? '1' : '0');
        if (!data.eu) { acceptAll(); return false; }
        return true;
    } catch {
        // Geo check failed — default to no banner (most traffic is US)
        acceptAll();
        return false;
    }
};
